module.exports = __webpack_public_path__ + "static/media/dot-icon.737b1bd5.svg";